var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHusLine01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.53,26.83L24.75,4.11l7.42,7.48v-3.47h6.71v10.31l8.19,8.39h-5.58l-.07.08s.04.04.04.06v18.51h-14.02v-11.08l-5.28-.03v11.11h-13.94l-.08-18.65H2.53ZM32.89,13.35l-8.1-8.19L4.29,26.11h4.54l.11,18.65h12.51v-11.17h6.71v11.17h12.51l.08-.08v-18.56h4.56l-.08-.17-7.07-7.18v-9.93h-5.28v4.51Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHusLine01);
export default __webpack_public_path__ + "static/media/hus_line-01.5276b502.svg";
export { ForwardRef as ReactComponent };